export default "__VITE_ASSET__Bn6SaVKG__"